<template>
<div class="container">
<!-- <div class="sun">

</div> -->
<p class="content">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nam vel lorem ac ligula fringilla .</p>
</div>    
</template>
    
    <script lang="ts">
    import {defineComponent} from 'vue'
    export default defineComponent({
        
        setup(){
            return{
                
            }
        }
    
    })
    </script>
    
    <style scoped lang="scss">
    .container{
        width: 100%;
        height: 100vh;
        background-color: #05096c;
        .content{
           color:white;
           font-size:34px;
           position: absolute;
           top:40%;
           text-align:left;
           padding-left:50px;
        }
    }
    
    </style>